import { TFunction } from 'i18next';

import { TimeOffChangedFieldNameDTO } from '../../types/dto/time-off-change-field-name.dto';

const FIELD_NAME_KEY: Record<TimeOffChangedFieldNameDTO, string> = {
  [TimeOffChangedFieldNameDTO.ALLOCATION_FORMAT]:
    'pages.timeOff.details.changesTab.fieldNames.allocationFormat',
  [TimeOffChangedFieldNameDTO.NUMBER_OF_DAYS]:
    'pages.timeOff.details.changesTab.fieldNames.numberOfDays',
  [TimeOffChangedFieldNameDTO.RENEWAL_DAY]:
    'pages.timeOff.details.changesTab.fieldNames.renewalDay',
  [TimeOffChangedFieldNameDTO.RENEWAL_MONTH]:
    'pages.timeOff.details.changesTab.fieldNames.renewalMonth',
  [TimeOffChangedFieldNameDTO.ALLOW_CARRYOVER]:
    'pages.timeOff.details.changesTab.fieldNames.allowCarryover',
  [TimeOffChangedFieldNameDTO.CARRYOVER_DAYS]:
    'pages.timeOff.details.changesTab.fieldNames.carryoverDays',
  [TimeOffChangedFieldNameDTO.MAXIMUM_BALANCE_LIMIT]:
    'pages.timeOff.details.changesTab.fieldNames.maximumBalanceLimit',
  [TimeOffChangedFieldNameDTO.ALLOW_NEGATIVE_BALANCE]:
    'pages.timeOff.details.changesTab.fieldNames.allowNegativeBalance',
  [TimeOffChangedFieldNameDTO.NEGATIVE_BALANCE_LIMIT]:
    'pages.timeOff.details.changesTab.fieldNames.negativeBalanceLimit',
  [TimeOffChangedFieldNameDTO.APPROVAL_REQUIRED]:
    'pages.timeOff.details.changesTab.fieldNames.approvalRequired',
  [TimeOffChangedFieldNameDTO.ALLOW_HALF_DAY]:
    'pages.timeOff.details.changesTab.fieldNames.allowHalfDay',
  [TimeOffChangedFieldNameDTO.ALLOW_QUARTER_DAY]:
    'pages.timeOff.details.changesTab.fieldNames.allowQuarterDay',
  [TimeOffChangedFieldNameDTO.ALLOW_HOURLY]:
    'pages.timeOff.details.changesTab.fieldNames.allowHourly',
  [TimeOffChangedFieldNameDTO.CONSIDER_USER_CAPACITY]:
    'pages.timeOff.details.changesTab.fieldNames.considerUserCapacity',
  [TimeOffChangedFieldNameDTO.REQUIRES_DOCUMENT]:
    'pages.timeOff.details.changesTab.fieldNames.requiresDocument',
  [TimeOffChangedFieldNameDTO.IS_BILLABLE]:
    'pages.timeOff.details.changesTab.fieldNames.isBillable',
  [TimeOffChangedFieldNameDTO.CREDIT_ON_CREATION]:
    'pages.timeOff.details.changesTab.fieldNames.creditOnCreation',
  [TimeOffChangedFieldNameDTO.PRORATE_ACCRUAL]:
    'pages.timeOff.details.changesTab.fieldNames.prorateAccrual',
  [TimeOffChangedFieldNameDTO.UNKNOWN]: 'pages.timeOff.details.changesTab.fieldNames.unknown',
};

/**
 * Maps a time-off changed-field name to its localized label.
 */
export const getLocalizedFieldName = (field: string, t: TFunction): string => {
  const key = FIELD_NAME_KEY[field as TimeOffChangedFieldNameDTO];
  return key ? t(key) : field;
};
